<!-- https://8es9hr.axshare.com/#g=1&p=%E6%94%BE%E6%AC%BE%E7%94%B3%E8%AB%8B_%E6%96%B0%E5%A2%9E
     https://8es9hr.axshare.com/#g=1&p=%E6%94%BE%E6%AC%BE%E7%94%B3%E8%AB%8B_%E6%AA%A2%E8%A6%96%E5%9F%BA%E6%9C%AC%E8%B3%87%E6%96%99
     https://8es9hr.axshare.com/#g=1&p=%E6%94%BE%E6%AC%BE%E7%94%B3%E8%AB%8B_%E4%B8%80%E8%88%AC%E6%94%BE%E6%AC%BE%E7%8B%80%E6%85%8B%E5%B1%95%E7%A4%BA
     https://8es9hr.axshare.com/#g=1&p=%E6%94%BE%E6%AC%BE%E7%94%B3%E8%AB%8B_%E6%8E%88%E6%AC%8A%E6%94%BE%E6%AC%BE%E7%8B%80%E6%85%8B%E5%B1%95%E7%A4%BA
     https://8es9hr.axshare.com/#g=1&p=%E6%94%BE%E6%AC%BE%E7%94%B3%E8%AB%8B_%E6%93%94%E4%BF%9D%E5%93%81%E6%94%BE%E6%AC%BE%E7%8B%80%E6%85%8B%E5%B1%95%E7%A4%BA
     https://8es9hr.axshare.com/#g=1&p=%E6%94%BE%E6%AC%BE%E7%94%B3%E8%AB%8B_%E5%85%A8%E7%8B%80%E6%85%8B%E5%B1%95%E7%A4%BA -->
<!-- 放款申請_新增
     放款申請_檢視基本資料
     放款申請_全狀態展示 -->
<template>
  <div class="row">
    <div class="col-12">
      <div style="display: flex">
        <Step
          :workflow="workflow"
          @goForm="goForm"
          v-if="$route.params.id !== 'new' && !$route.meta.flowNotKeepAlive"
          :isAutoDisabled="true"
        ></Step>

        <div
          class="step-form"
          :class="{ dib: $route.params.id == 'new' }"
          v-if="$route.meta.formKeepAlive"
        >
          <ListForm
            api="coopLoanApply"
            :id="id"
            labelPosition="top"
            formTitle="填寫申請資料"
            :rules="rules"
            :recordToEdit="recordToEdit"
            :formType="formType"
            @formCB="formCB"
          >
            <div class="dialog-footer" slot="footer" v-if="btnHide">
              <el-button @click="back">返回</el-button>
            </div>
          </ListForm>
        </div>
        <div
          :class="{
            'step-form': !$route.meta.flowNotKeepAlive,
            w100p: $route.meta.flowNotKeepAlive,
          }"
          v-else
        >
          <router-view
            :currentFlow="currentFlow"
            :reviewFlowEnum="reviewFlowEnum"
            :title="title"
            :titleLabel="title"
            :workflow="workflow"
            :coopLoanProject="coopLoanProjectObject"
            :coopLoanProjectCode="recordToEdit.coopLoanProjectCode"
          ></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ListForm from "@/components/ListForm.vue";
import Step from "@/components/Step.vue";
import { API } from "@/assets/config";

export default {
  name: "loan_application_edit",
  components: {
    ListForm,
    Step,
  },
  data() {
    let recordToEdit = {
      memberId: 0,
      installmentNumbers: 0,
      installmentMonths: 0,
      applyTypeIouCodes: "",
      applyTypeDesc: 0,
      // 期還金額試算計算式(hint 顯示用，預先宣告確保反應性)
      installmentAmountFormula: "",
    };
    return {
      titleLabel: "基本資料",
      title: "基本資料",
      coopParams: {},
      coopLoanProjectObject: {},
      reviewFlowEnum: {},
      currentFlow: {},
      btnHide: false,
      workflow: [],

      isFirst: true,
      id: this.$route.params.id == "new" ? 0 : this.$route.params.id,
      flowStatus: -1,
      memberChoose: {},
      recordToEdit,
      memberIouPrice: [],
      actionMap: [
        {
          label: "基本資料",
          route: "loan_application_edit",
          routeParam: "send",
          mapDesc: "基本資料",
          statusType: "form",
          ststus: "",
          statusCode: 0,
        },
        {
          label: "保證人",
          route: "loan_application_guarantor",
          routeParam: null,
          mapDesc: "保證人",
          statusType: "form",
          ststus: "",
          statusCode: 1,
        },
        {
          label: "檢附文件",
          route: "loan_application_doc",
          routeParam: null,
          mapDesc: "檢附文件",
          statusType: "form",
          ststus: "",
          statusCode: 2,
        },
        {
          label: "財務狀況",
          route: "loan_application_financial",
          routeParam: null,
          mapDesc: "財務狀況",
          statusType: "form",
          ststus: "",
          statusCode: 3,
        },
        {
          label: "股金借款紀錄表",
          route: "loan_application_stock",
          routeParam: null,
          mapDesc: "股金借款紀錄表",
          statusType: "form",
          ststus: "",
          statusCode: 4,
        },
        {
          label: "主任審查",
          route: "loan_application_review",
          routeParam: "director",
          mapDesc: "主任審查",
          statusType: "review",
          ststus: "",
          statusCode: 5,
        },
        {
          label: "經理審查",
          route: "loan_application_review",
          routeParam: "manager",
          mapDesc: "經理審查",
          statusType: "review",
          ststus: "",
          statusCode: 5,
        },
        {
          label: "擔保品鑑價與審查",
          route: "loan_application_collateral",
          routeParam: "valuation",
          mapDesc: "擔保品鑑價與審查",
          statusType: "form",
          ststus: "",
          statusCode: 6,
        },
        {
          label: "擔保品鑑價主任審查",
          route: "loan_application_review",
          routeParam: "valuationDirector",
          mapDesc: "擔保品鑑價主任審查",
          statusType: "review",
          ststus: "",
          statusCode: 6,
        },
        {
          label: "擔保品鑑價經理審查",
          route: "loan_application_review",
          routeParam: "valuationManager",
          mapDesc: "擔保品鑑價經理審查",
          statusType: "review",
          ststus: "",
          statusCode: 6,
        },
        {
          label: "放款委員會報表列印",
          route: "loan_application_reportprint",
          routeParam: null,
          mapDesc: "放款委員會報表列印",
          statusType: "form",
          ststus: "",
          statusCode: 7,
        },
        {
          label: "放款委員會審查紀錄",
          route: "loan_application_committeereview",
          routeParam: "committee",
          mapDesc: "放款委員會審查紀錄",
          statusType: "committee",
          ststus: "",
          statusCode: 8,
        },
        {
          label: "理事會審查紀錄",
          route: "loan_application_committeereview",
          routeParam: "council",
          mapDesc: "理事會審查紀錄",
          statusType: "council",
          ststus: "",
          statusCode: 9,
        },
        {
          label: "擔保品設定與審查",
          route: "loan_application_collateral",
          routeParam: "setting",
          mapDesc: "擔保品設定與審查",
          statusType: "form",
          ststus: "",
          statusCode: 10,
        },
        {
          label: "擔保品設定主任審查",
          route: "loan_application_review",
          routeParam: "settingDirector",
          mapDesc: "擔保品設定主任審查",
          statusType: "review",
          ststus: "",
          statusCode: 10,
        },
        {
          label: "擔保品設定經理審查",
          route: "loan_application_review",
          routeParam: "settingManager",
          mapDesc: "擔保品設定經理審查",
          statusType: "review",
          ststus: "",
          statusCode: 10,
        },
        {
          label: "借據及對保資料",
          route: "loan_application_borrowing",
          routeParam: null,
          mapDesc: "借據及對保資料",
          statusType: "form",
          ststus: "",
          statusCode: 11,
        },
        {
          label: "追認作業",
          route: "loan_application_ratification",
          routeParam: null,
          mapDesc: "追認作業",
          statusType: "form",
          ststus: "",
          statusCode: 12,
        },
      ],
      formType: [
        {
          label: "社員帳號",
          key: "memberId",
          type: "chooseMember",
          returnKey: "id",
          require: true,
          filter: {
            isFormal: 1,
            isExit: 0,
          },
        },
        {
          label: "股金餘額",
          key: "memberStockAmount",
          type: "input",
          disabled: true,
          replaceComma: true,
        },
        {
          label: "備轉金餘額",
          key: "memberTransferAmount",
          type: "input",
          disabled: true,
          replaceComma: true,
        },
        {
          label: "申請用途",
          key: "genLoanTypesId",
          type: "select",
          options: [],
          require: true,
        },
        {
          label: "申請類型",
          key: "applyType",
          type: "radio",
          options: [],
          require: true,
          validateEmptyFunc: (item) =>
            this.recordToEdit[item.key] === "" ||
            this.recordToEdit[item.key] === undefined,
        },
        {
          label: "",
          type: "text",
          key: "applyTypeDesc",
          options: [
            "一般借款。（不可用來償還其他借款）",
            "以原有借款餘額並增加借款金額而新辦理之借款。（新借款金額內一部份金額，用來償還某一筆全數貸款餘額）",
            "以原有借款餘額重新辦理相同金額之借款。",
          ],
        },
        {
          label: "借據",
          key: "applyTypeIouCodeList",
          type: "multicascader",
          valueKey: "value",
          options: [],
          vif: false,
          palceholderTitleChange: "請輸入原借據編號用逗點分隔",
        },
        {
          title: "申請方案",
          type: "title",
        },
        {
          label: "申請方案名稱",
          key: "coopLoanProjectCode",
          type: "select",
          options: [],
          filterable: true,
          require: true,
        },
        {
          label: "本金還款寬限(月)",
          key: "securedGraceMonths",
          type: "input",
          vif: false,
        },
        {
          key: "isLicenseMode",
          type: "checkbox",
          options: [
            {
              label: "使用授權審核流程",
            },
          ],
          vif: false,
        },
        {
          label: "還款期數",
          key: "installmentNumbers",
          type: "input",
          require: true,
        },
        {
          label: "每期月數",
          key: "installmentMonths",
          type: "number",
          min: 1,
          max: 6,
          require: true,
        },
        {
          label: "申請金額",
          key: "applyAmount",
          type: "input",
          addcomma: true,
          require: true,
        },
        //還款試算
        {
          label: "期還金額(試算)",
          key: "installmentAmountTrial",
          type: "input",
          disabled: true,
          hintKey: "installmentAmountFormula",
        },
        {
          label: "備註",
          key: "applyMemo",
          type: "textarea",
        },
        {
          key: "applyTypeIouCodes",
          value: "",
          type: "post",
        },
      ],
      rules: {
        amount: [{ required: true, message: "請輸入金額", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getData();
    this.getWorkflow();
  },
  watch: {
    "recordToEdit.memberId": function () {
      this.getMemberInfo();
    },
    "recordToEdit.coopLoanProjectCode": {
      immediate: false,
      handler(newVal, oldVal) {
        const proj = this.coopLoanProjectObject[newVal];
        // 方案資料尚未載入或查無對應方案時，直接結束避免存取 undefined 報錯
        if (!proj) return;

        const securedGraceMonthsField = this.getField("securedGraceMonths");
        const isLicenseModeField = this.getField("isLicenseMode");

        const showSecuredGrace = proj.loanType == 2 && proj.isSecuredGrace == 1;
        const showLicenseMode = proj.loanType == 1;

        securedGraceMonthsField.vif = showSecuredGrace;
        securedGraceMonthsField.require = showSecuredGrace;
        isLicenseModeField.vif = showLicenseMode;

        // 使用者「切換」方案時，初始化與方案綁定的相關設定，
        // 避免被隱藏的欄位殘留前一個方案的值被送出（例如寬限月數）。
        // oldVal 為 undefined 代表是載入既有申請資料，此時保留後端帶回的值。
        if (oldVal !== undefined && oldVal !== newVal) {
          this.$set(this.recordToEdit, "securedGraceMonths", 0);
          this.$set(this.recordToEdit, "isLicenseMode", 0);
        }

        this.calInstallmentAmount();
      },
    },
    "recordToEdit.applyAmount": function () {
      this.calInstallmentAmount();
    },
    "recordToEdit.installmentNumbers": function () {
      this.calInstallmentAmount();
    },
    "recordToEdit.installmentMonths": function () {
      this.calInstallmentAmount();
    },
    "recordToEdit.securedGraceMonths": function () {
      this.calInstallmentAmount();
    },
    "recordToEdit.applyTypeIouCodeList": {
      handler(oldVal, newVal) {
        const tmpArray = Array.isArray(this.recordToEdit.applyTypeIouCodeList)
          ? this.recordToEdit.applyTypeIouCodeList
          : [this.recordToEdit.applyTypeIouCodeList];

        // 將選擇借據號碼轉換後放入表單資料中
        this.getField("applyTypeIouCodes").value = encodeURI(
          JSON.stringify(tmpArray)
        );

        // 未提交表單會自動加總借款金額
        if (this.recordToEdit.isSubmit !== 1) {
          const iouAmounts = this.memberIouPrice
            .filter((iouPrice) => tmpArray.includes(iouPrice.iouNumber))
            .map((iouPrice) => iouPrice.amount);
          const iouAmountSum = iouAmounts.length > 0 ? iouAmounts.reduce((acc, cur) => acc + cur) : 0;
          if (this.recordToEdit.applyType == 2 || this.recordToEdit.applyAmount < iouAmountSum) {
            this.recordToEdit.applyAmount = iouAmountSum;
          }
        }
      },
    },
    "recordToEdit.applyType": {
      immediate: true,
      handler(oldVal, newVal) {
        const iouCodeListField = this.getField("applyTypeIouCodeList")
        this.recordToEdit.applyTypeDesc = this.recordToEdit.applyType;
        if (
          this.recordToEdit.applyType == 2 ||
          this.recordToEdit.applyType == 1
        ) {
          iouCodeListField.vif = true;
          iouCodeListField.require = true;
        } else {
          this.recordToEdit.applyTypeIouCodeList = [];
          iouCodeListField.vif = false;
        }
      },
    },
    $route(to, from) {
      this.id = to.params.id;
      this.getWorkflow();
      this.getData();
      if (to.name == "loan_application_edit") {
        this.getMemberInfo();
      }
    },
  },
  // updated() {
  //     let gotoFlow = this.workflow.find(
  //         flow => flow.statusCode == this.flowStatus
  //     );
  //     if (gotoFlow && this.isFirst) {
  //         this.go(gotoFlow.route, gotoFlow.routeParam, gotoFlow);
  //         this.isFirst = false;
  //     }
  // },
  methods: {
    async getMemberInfo() {
      if (!this.recordToEdit.memberId) return;

      let url = API.coopLoanApply + `?action=getMemberInfo&memberId=${this.recordToEdit.memberId}`;
      try {
        const json = await this.mAxiosGet(url);

        this.memberChoose = json.resultData.member;
        this.$set(
          this.recordToEdit,
          "memberStockAmount",
          this.$addcomma(json.resultData.memberStockAmount)
        );
        this.$set(
          this.recordToEdit,
          "memberTransferAmount",
          this.$addcomma(json.resultData.memberTransferAmount)
        );
        this.memberIouPrice = json.resultData.iouPrice;

        if (this.recordToEdit.isSubmit !== 1) {
          this.getField("applyTypeIouCodeList").options = json.resultData.memberIou.map((iou) => {
            return {
              name: `借據${iou.iouNumber}`,
              value: iou.iouNumber,
            };
          });
        }
      } catch (error) {
        console.error("getMemberInfo failed", error);
      }
    },
    getField(key) {
      return this.formType.find((item) => item.key == key);
    },
    // 期還金額試算：本息攤還(CAM)為每期還款本金、本息定額(CPM)為含息期金，
    // 期數需扣除本金還款寬限期數(寬限月數/每期月數)，與 CoopLoanTrialTableBR 的算法一致
    // 另同步產生顯示用的計算式字串 installmentAmountFormula
    calInstallmentAmount() {
      const proj = this.coopLoanProjectObject[this.recordToEdit.coopLoanProjectCode];
      const price = parseInt(
        String(this.recordToEdit.applyAmount || "").replace(/,/g, ""),
        10
      );
      const stages = parseInt(this.recordToEdit.installmentNumbers, 10);
      const periodMonth = parseInt(this.recordToEdit.installmentMonths, 10);
      const graceMonths =
        parseInt(this.recordToEdit.securedGraceMonths, 10) || 0;

      if (!proj || !price || !stages || !periodMonth) {
        this.$set(this.recordToEdit, "installmentAmountTrial", "");
        this.$set(this.recordToEdit, "installmentAmountFormula", "");
        return;
      }

      // 實際攤還期數 = 期數 - 本金還款寬限期數
      const graceStages = Math.floor(graceMonths / periodMonth);
      const payStages = Math.max(stages - graceStages, 1);

      // 攤還期數運算式：有寬限期才顯示扣除，讓計算式與寬限月欄位對得起來
      const stagesExpr =
        graceStages > 0 ? `(${stages} − ${graceStages}期寬限)` : `${stages}`;

      let amount;
      let formulaBody;
      if (proj.normalPaymentType == 2) {
        // 本息定額(CPM)：期金 PMT，每期利率 = 年利率/100/12 × 每期月數
        const rate =
          ((parseFloat(proj.normalAnnualRate) || 0) / 100 / 12) * periodMonth;
        amount =
          rate === 0
            ? price / payStages
            : (price * rate) / (1 - Math.pow(1 + rate, -payStages));
        formulaBody = `本息定額 PMT：本金 ${this.$addcomma(
          price
        )}、攤還 ${payStages} 期、月利率 ${(rate * 100).toFixed(4)}%`;
      } else {
        // 本息攤還(CAM)：每期還款本金(利息依餘額另計)
        amount = price / payStages;
        formulaBody = `本息攤還：${this.$addcomma(price)} ÷ ${stagesExpr}`;
      }

      const rounded = Math.round(amount);
      this.$set(
        this.recordToEdit,
        "installmentAmountTrial",
        this.$addcomma(rounded)
      );
      this.$set(
        this.recordToEdit,
        "installmentAmountFormula",
        `${formulaBody} ＝ ${this.$addcomma(rounded)}`
      );
    },
    getFlowStatus(workflow, statusType) {
      const formStatus = ["未填寫", "填寫中", "填寫完成"];
      const committeeStatus = [
        "等待中",
        "審查中",
        "通過",
        "不通過",
        "補件後重審",
        "補件後直接提交理事會",
      ];
      const councilStatus = [
        "等待中",
        "審查中",
        "通過",
        "不通過",
        "補件後重審",
      ];
      const reviewStatus = ["等待中", "審查中", "通過", "不通過", "中止"];
      switch (statusType) {
        case "form":
          return formStatus[workflow.status];
        case "committee":
          return committeeStatus[workflow.status];
        case "council":
          return councilStatus[workflow.status];
        case "review":
          return reviewStatus[workflow.status];
      }
    },
    async getWorkflow() {
      const url = API.coopLoanApply + `?action=workflow&id=${this.id}`;
      this.isFinish = false;
      try {
        const json = await this.mAxiosGet(url);
        
        this.reviewFlowEnum = json.resultData.enumData.workFlowReviewStatus;
        this.workflow = json.resultData.data;
        this.btnHide = this.workflow.some((item, idx) => {
          if (item.label == this.titleLabel && item.status == 2) {
            return true;
          }
        });
        if (this.isFirst) {
          this.workflow.some((item) => {
            if (item.status == 1) {
              this.title = item.label;
              this.actionMap.filter((workflow) => {
                if (workflow.label == item.label) {
                  this.go(workflow.route, workflow.routeParam, workflow);
                }
              });
            }
          });

          this.isFirst = false;
        }
      } catch (error) {
        console.error("getWorkflow failed", error);
      }
    },
    async getData() {
      let tmpId = this.id == "new" ? 0 : this.id;
      const url = API.coopLoanApply + `?id=${tmpId}`;
      try {
        const json = await this.mAxiosGet(url);

        this.flowStatus = json.resultData.data.status;

        const applyType = json.resultData.data.applyType;
        let applyTypeIouCodeList = [];
        if (applyType == 1 || applyType == 2) {
          let applyTypeIouCodesRaw = json.resultData.data.applyTypeIouCodes || "%5B%5D";
          let applyTypeIouCodes = [];
          try {
            applyTypeIouCodes = JSON.parse(decodeURI(applyTypeIouCodesRaw))
              .filter((iouNumber) => iouNumber !== "");
          } catch (e) {
            applyTypeIouCodes = [];
          }

          // 增貸、換單皆載入全部關聯借據
          applyTypeIouCodeList = applyTypeIouCodes;
        }
        
        // 載入已選擇的借據選項
        this.getField("applyTypeIouCodeList").options = applyTypeIouCodeList.map((iouNumber) => {
          return {
            name: `借據${iouNumber}`,
            value: iouNumber,
          };
        });

        let newObj = {
          ...json.resultData.data,
          applyAmount: this.$addcomma(json.resultData.data.applyAmount),
          applyTypeIouCodeList: applyTypeIouCodeList,
        };
        this.recordToEdit = Object.assign({}, this.recordToEdit, newObj);
        this.coopParams = json.resultData.enumData.coopParams;
        // 申請用途
        this.getField("genLoanTypesId").options = json.resultData.enumData.genLoanTypes;
        // 申請類型
        this.getField("applyType").options = json.resultData.enumData.applyType;
        // 申請方案名稱
        this.getField("coopLoanProjectCode").options = json.resultData.enumData.coopLoanProject.map(
          function (proj) {
            return { label: proj.name, value: proj.code };
          }
        );
        this.coopLoanProjectObject = this.getLoanProjectObject(
          json.resultData.enumData.coopLoanProject
        );
      } catch (error) {
        console.error("getData failed", error);
      }
    },
    getLoanProjectObject(projectArrray) {
      let result = {};
      projectArrray.forEach((element) => {
        result[element.code] = element;
      });
      return result;
    },
    go(name, query, flow = null) {
      this.$router.push({ name: name, query: { type: query } });
      this.currentFlow = flow;
    },
    formCB() {
      // this.getWorkflow();
      this.go("loan_application_guarantor", "保證人");
    },
    goForm(item) {
      this.titleLabel = ""; //點選左邊step按鈕時會切換到當下頁面
      this.titleLabel = item.label;

      this.actionMap.filter((keys) => {
        if (keys.label == item.label) {
          this.$router.push({
            name: keys.route,
            query: { type: keys.routeParam },
            params: {
              titleLabel: item.label,
            },
          });
        }
      });
    },
    back() {
      this.$router.push({
        name: "loan_application",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-step {
  cursor: pointer;
}
.dib {
  display: block;
  width: 100%;
  margin-left: 0;
}
.mg {
  margin-right: 15px;
}
</style>